export const environment = {
  production: false,
  apiUrl: 'https://test.drshaileshsancheti.com/api',
};
